import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import getLang from 'I18n/utils/getLang';
import { DescriptionList } from 'foundations-components/transitional/components/DescriptionList';
import { Link } from 'foundations-components/transitional/components/Link';
import { List } from 'foundations-components/transitional/components/List';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Fragment } from 'react';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { getFormattedUrl, getHubSpotAcceptableUseUrl, getHubSpotPrivacyUrl, getHubSpotTermsOfServiceUrl } from '../utils/DetailsPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function LegalNotice({
  productType,
  builtByHubSpot,
  langCode,
  onTrackInteraction = () => {}
}) {
  switch (productType) {
    case 'AGENT':
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "detailsPage.infoCard.legal.agent.legalNotice_jsx",
        options: {
          aiProductsTermsLink: {
            href: 'https://legal.hubspot.com/product-specific-terms#AI-prod',
            external: true,
            onClick: () => {
              onTrackInteraction({
                action: 'click ai products terms link'
              });
            }
          },
          hubspotBetaTermsLink: {
            href: 'https://legal.hubspot.com/hubspot-beta-terms',
            external: true,
            onClick: () => {
              onTrackInteraction({
                action: 'click hubspot beta terms link'
              });
            }
          },
          behindHubSpotAILink: {
            href: 'https://trust.hubspot.com/ai',
            external: true,
            onClick: () => {
              onTrackInteraction({
                action: 'click behind hubspot ai link'
              });
            }
          }
        },
        elements: {
          Link
        }
      });
    case 'APP':
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: builtByHubSpot ? 'detailsPage.infoCard.legal.app.homemadeDataEnrichmentNotice_jsx' : 'detailsPage.infoCard.legal.app.dataEnrichmentNotice_jsx',
        options: {
          aupLink: {
            href: getHubSpotAcceptableUseUrl(langCode),
            external: true,
            onClick: () => {
              onTrackInteraction({
                action: 'click acceptable use policy link'
              });
            }
          },
          tosLink: {
            href: getHubSpotTermsOfServiceUrl(langCode),
            external: true,
            onClick: () => {
              onTrackInteraction({
                action: 'click customer terms of service link'
              });
            }
          }
        },
        elements: {
          Link
        }
      });
    default:
      return null;
  }
}
export function LegalTab({
  builtByHubSpot,
  onTrackInteraction = () => {},
  privacyUrl1,
  privacyUrl2,
  privacyUrl3,
  termsUrl
}) {
  const langCode = getLang();
  const {
    productType
  } = useDetailsPageContext();
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx("p", {
      children: /*#__PURE__*/_jsx(LegalNotice, {
        productType: productType,
        builtByHubSpot: builtByHubSpot,
        langCode: langCode,
        onTrackInteraction: onTrackInteraction
      })
    }), /*#__PURE__*/_jsxs(DescriptionList, {
      children: [productType === 'APP' && builtByHubSpot && /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.infoCard.legal.privacyPolicyHomemade_jsx",
          options: {
            privacyPolicyLink: {
              href: getHubSpotPrivacyUrl(langCode),
              external: true,
              onClick: () => {
                onTrackInteraction({
                  action: 'click product privacy policy link'
                });
              }
            }
          },
          elements: {
            Link
          }
        })
      }), productType === 'APP' && !builtByHubSpot && privacyUrl1 && termsUrl && /*#__PURE__*/_jsx("dd", {
        children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
          message: "detailsPage.infoCard.legal.privacyPolicy_jsx",
          options: {
            privacyLinkProps: {
              href: getFormattedUrl(privacyUrl1) || '',
              external: true,
              onClick: () => onTrackInteraction({
                action: 'click privacy policy link'
              })
            },
            tosLinkProps: {
              href: getFormattedUrl(termsUrl) || '',
              external: true,
              onClick: () => onTrackInteraction({
                action: 'click terms link'
              })
            }
          },
          elements: {
            Link
          }
        })
      }), (privacyUrl2 || privacyUrl3) && /*#__PURE__*/_jsxs(Fragment, {
        children: [/*#__PURE__*/_jsx("dt", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "detailsPage.infoCard.legal.additionalPrivacyInformationLabel"
          })
        }), /*#__PURE__*/_jsx("dd", {
          children: /*#__PURE__*/_jsxs(List, {
            children: [privacyUrl2 && /*#__PURE__*/_jsx(Link, {
              href: getFormattedUrl(privacyUrl2) || '',
              onClick: () => onTrackInteraction({
                action: 'click other privacy policy link'
              }),
              children: /*#__PURE__*/_jsx(TruncateString, {
                children: privacyUrl2
              })
            }), privacyUrl3 && /*#__PURE__*/_jsx(Link, {
              href: getFormattedUrl(privacyUrl3) || '',
              onClick: () => onTrackInteraction({
                action: 'click other privacy policy link'
              }),
              children: /*#__PURE__*/_jsx(TruncateString, {
                children: privacyUrl3
              })
            })]
          })
        })]
      })]
    })]
  });
}